import React, { useState } from 'react';
import { Button, Container, Form, FormControl, Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { FaSearch } from 'react-icons/fa';
import styled from 'styled-components';
import SearchModal from './SearchModal';
import { Link } from 'gatsby';
import { IndexQuery } from '../../../graphql-types';

type Props = {
  data : IndexQuery
}

function Header(props: Props) {
  const { data } = props;
  const Wrapper = styled.header`
    /* border-bottom: 10px solid #000; */
    background-color: white;
    a,svg{text-decoration: none;color:white;font-weight:normal;}
    .navbar-brand a{font-weight: bold;}
    .btn-link{ text-decoration:none; color:white; font-weight:normal; }
  `;
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <Wrapper>
      <Navbar expand="md" sticky="top" bg="dark" variant="dark">
        <Container fluid>
          <Navbar.Brand as={"div"}>
            <Link to={`/`}>{data.site.siteMetadata.title}</Link>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="navbarResponsive" />
          <Navbar.Collapse>
          {data.site.siteMetadata.headerLinks.map(link =>(
            <Nav.Link as={"div"} key={link.label}>
              <Link to={link.url}>{link.label}</Link>
            </Nav.Link>
          ))}
          </Navbar.Collapse>
          <Navbar.Collapse className="justify-content-end">
            <Button variant="link" onClick={handleShow}>
              <FaSearch /> サイト内検索
            </Button>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <SearchModal show={show} onHide={handleClose} />
    </Wrapper>
  );
}

export default Header;
